import type { UsersProfileTypes } from "@/redux/usersProfile/usersProfileTypes";

export const usersProfileReducer = {
  resetError: (state: UsersProfileTypes) => {
    state.error = null;
  },
  resetSuccess: (state: UsersProfileTypes) => {
    state.success = null;
  },

  resetUsersProfileFetching: (state: UsersProfileTypes) => {
    state.fetching = false;
  },

  resetUsersProfileMessage: (state: UsersProfileTypes) => {
    state.message = null;
  },
  resetPanMessage: (state: UsersProfileTypes) => {
    state.panMessage = null;
  },
  resetPanError: (state: UsersProfileTypes) => {
    state.panError = null;
  },
  resetStatusCodePan: (state: UsersProfileTypes) => {
    state.statusCodePan = null;
  },

  resetAadhaarMessage: (state: UsersProfileTypes) => {
    state.aadhaarMessage = null;
  },
  resetAadhaarError: (state: UsersProfileTypes) => {
    state.aadhaarError = null;
  },
  resetStatusCodeAadhaar: (state: UsersProfileTypes) => {
    state.statusCodeAadhaar = null;
  },
  resetPanSuccess: (state: UsersProfileTypes) => {
    state.panSuccess = null;
  },
  resetAaddharSuccess: (state: UsersProfileTypes) => {
    state.aadhaarSuccess = null;
  },

  resetPassportMessage: (state: UsersProfileTypes) => {
    state.passportMessage = null;
  },
  resetPassportError: (state: UsersProfileTypes) => {
    state.passportError = null;
  },
  resetStatusCodePassport: (state: UsersProfileTypes) => {
    state.statusCodePassport = null;
  },
  resetPassportSuccess: (state: UsersProfileTypes) => {
    state.passportSuccess = null;
  },
  resetUanMessage: (state: UsersProfileTypes) => {
    state.uanMessage = null;
  },
  resetUanError: (state: UsersProfileTypes) => {
    state.uanError = null;
  },
  resetUanSuccess: (state: UsersProfileTypes) => {
    state.uanSuccess = null;
  },
  resetStatusCodeUan: (state: UsersProfileTypes) => {
    state.statusCodeUan = null;
  },
};
